"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect } from "react";
import { MapPin, Clock } from "lucide-react";
export default function CoastalCleaningLlc() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.zocdoc.com/js/zdwidget.js";
    script.setAttribute("data-type", "book-button");
    script.setAttribute("data-practice-id", "102513");
    const bookingElement = document.getElementById("zocdoc-booking");
    if (bookingElement) {
      bookingElement.appendChild(script);
    }
  }, []);
  return <section data-section-id="225433" id="your-health-our-priority" ref={sectionRef} className={`relative w-full min-h-[100svh] flex items-center justify-center bg-gradient-to-br from-background via-background to-accent/20 text-foreground overflow-hidden transition-opacity duration-1000 ${isSectionVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 py-12 md:py-24 lg:py-32 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div className="flex justify-center lg:justify-end order-1 lg:order-none">
            <div className="relative w-full max-w-[300px] aspect-square !h-[150px] sm:max-w-[400px]">
              <div className="absolute inset-0 bg-ring/10 blur-3xl rounded-full scale-125 animate-pulse !h-[150px]" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638797/img/dr_kaszuba_primary_care_logo.png" alt="Dr. Kaszuba's Primary Care Walk-In Clinic Logo" className="relative w-full object-contain drop-shadow-2xl !m-0 !h-[150px]" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col space-y-6 order-2 lg:order-none transition-all duration-1000 delay-300 transform ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="flex items-center justify-between w-full border-b-2 border-primary/10 pb-2">
              <span className="font-default font-bold text-sm sm:text-base tracking-widest uppercase text-accent-foreground">
                Patient-Centered
              </span>
              <span className="font-default font-bold text-sm sm:text-base tracking-widest uppercase text-accent-foreground">
                Walk-In Clinic
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-none tracking-tighter text-primary !text-4xl">
              StemWave<br />Acoustic Wave<br />Therapy
            </h1>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[{
              title: "Musculoskeletal",
              desc: "Advanced care for joints and muscles."
            }, {
              title: "Pain Relief",
              desc: "Solutions for acute and chronic pain."
            }, {
              title: "Men's Health",
              desc: "Non-invasive erectile dysfunction therapy."
            }].map((item, i) => <div key={item.title} data-index={i} className="bg-card border border-border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <h3 className="font-bold text-primary text-xs uppercase tracking-widest mb-1">{item.title}</h3>
                  <p className="text-[10px] sm:text-xs text-muted-foreground leading-tight">{item.desc}</p>
                </div>)}
            </div>

            {}
            <p className="font-default italic tracking-wide !font-medium !bg-transparent text-muted-foreground !text-lg">
              Professional medical care with a personal touch in Safety Harbor.
            </p>

            {}
            <div className="flex flex-col space-y-4 pt-4">
              <div className="flex flex-col space-y-1">
                <span className="font-default font-bold text-lg uppercase tracking-wider text-primary">Dr.Kaszuba's Primary Care</span>
                <span className="font-default font-bold italic text-xl text-accent-foreground">
                  727-216-0505
                </span>
              </div>

              {}
              <div className="flex flex-col space-y-3 pt-2 border-t border-primary/10">
                <div className="flex items-center gap-3">
                  <MapPin className="size-5 text-ring shrink-0" />
                  <span className="font-default text-sm text-muted-foreground">
                    1803 Briar Creek Blvd, Safety Harbor, FL 34695
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Clock className="size-5 text-ring shrink-0" />
                  <span className="font-default text-sm text-muted-foreground">
                    Mon–Fri 9am–5pm | Sat 10am–1pm | Sun Closed
                  </span>
                </div>
              </div>

              {}
              <div className="w-full h-48 rounded-lg overflow-hidden border border-border shadow-sm mt-2">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3523.585542713837!2d-82.686561!3d27.975945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2ee03e7c85667%3A0x6d9f8e9f5e9e9e9e!2s1803%20Briar%20Creek%20Blvd%2C%20Safety%20Harbor%2C%20FL%2034695!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" width="100%" height="100%" className="border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
              </div>

              {}
              <div className="pt-6">
                <div id="zocdoc-booking"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}